export const congregationConsts = {
    LOAD_REQUEST: '[Congregation] LOAD_REQUEST',
    LOAD_SUCCESS: '[Congregation] LOAD_SUCCESS',
    LOAD_FAILURE: '[Congregation] LOAD_FAILURE',
};
